import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'
import DialogoCupoUpdate from '../../components/asignacionCupos/DialogoCupoUpdate'

function OperacionesNominacion (props) {
  const [openCupo, setOpenCupo] = useState(false)

  const handleCloseCupo = () => {
    setOpenCupo(false)
  }

  const handleSubmitCupo = async (datosDeCupoCache, nuevaCantidad) => {
    props.modificarCantidadNominacionCache(datosDeCupoCache, nuevaCantidad)
    handleCloseCupo()
  }

  function onClick () {
    const { tableMeta } = props
    console.log('rowData', tableMeta)
    props.eliminarNominacionCache(tableMeta.rowData)
  }

  return (
    <div>
      <Dialog
        open={openCupo}
        onClose={handleCloseCupo}
        fullWidth
        maxWidth='xs'>
        <DialogoCupoUpdate data={props.tableMeta.rowData} handleClose={handleCloseCupo} handleSubmit={handleSubmitCupo} />
      </Dialog>
      <Tooltip title={'Modificar cantidad'}>
        <IconButton onClick={() => setOpenCupo(true)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Eliminar Nominación'}>
        <IconButton onClick={onClick}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesNominacion)
